module.exports = {
	"library.footer.terms_of_use": "Käyttöehdot",
	"library.footer.terms_and_conditions": "Käyttöehdot",
	"library.footer.privacy_policy": "Tietosuojakäytäntö",
	"library.footer.get_to_know_us": "Opi tuntemaan meidät",
	"library.footer.about": "Tietoja",
	"library.footer.jobs": "Työpaikat",
	"library.footer.blog": "Bloki",
	"library.footer.get_help": "Hanki apua",
	"library.footer.find_events": "Etsi tapahtumia",
	"library.footer.top_events": "Huipputapahtumat",
	"library.footer.host_events": "Isännöi tapahtumia",
	"library.footer.become_a_host": "Ryhdy järjestäjäksi",
	"library.footer.tour": "Kiertue",
	"library.footer.embeddable_widgets": "Upotettavat pienoisohjelmat",
	"library.footer.customers": "Asiakkaat",
	"library.footer.pricing": "Hinnoittelu",
	"library.footer.get_the_onsite_app": "Hanki paikan päällä käytettävä sovellus",
	"library.footer.developers": "Kehittäjät",
	"library.footer.contact_us": "Ota meihin yhteyttä"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/fi.json
// module id = 1597
// module chunks = 0 1 2 4 5 6 7 8 9 10 11 12 13 14 15 16